const diretoria = {
  diretores: [
    {
      nome: 'Carlos Ambrósio',
      cargo: 'Presidente',
      descricao: 'Claritas Administração de Recursos',
      imagem: 'diretoria1',
    },
    {
      nome: 'Carlos André',
      cargo: 'Vice-presidente',
      descricao: 'BB DTVM',
      imagem: 'diretoria2',
    },
    {
      nome: 'Carlos Constantini',
      cargo: 'Vice-presidente',
      descricao: 'Itaú Unibanco',
      imagem: 'diretoria3',
    },
    {
      nome: 'José Eduardo Laloni',
      cargo: 'Vice-presidente',
      descricao: 'ABC Brasil',
      imagem: 'diretoria4',
    },
    {
      nome: 'Luiz Sorge',
      cargo: 'Vice-presidente',
      descricao: 'BNP Paribas Brasil',
      imagem: 'diretoria5',
    },
    {
      nome: 'Miguel Ferreira',
      cargo: 'Vice-presidente',
      descricao: 'Santander',
      imagem: 'diretoria6',
    },
    {
      nome: 'Pedro Lorenzini',
      cargo: 'Vice-presidente',
      descricao: 'Citibank',
      imagem: 'diretoria7',
    },
    {
      nome: 'Renato Ejnisman',
      cargo: 'Vice-presidente',
      descricao: 'Bradesco',
      imagem: 'diretoria8',
    },
    {
      nome: 'Sergio Cutolo',
      cargo: 'Vice-presidente',
      descricao: 'BTG Pactual',
      imagem: 'diretoria9',
    },
    {
      nome: 'Adriano Koelle',
      cargo: 'Diretor',
      descricao: 'BNY Mellon',
      imagem: 'diretoria10',
    },
    {
      nome: 'Alcindo Canto',
      cargo: 'Diretor',
      descricao: 'Votorantim',
      imagem: 'diretoria11',
    },
    {
      nome: 'Fernando Rabello',
      cargo: 'Diretor',
      descricao: 'Safra',
      imagem: 'diretoria12',
    },
    {
      nome: 'Jan Karsten',
      cargo: 'Diretor',
      descricao: 'GPS',
      imagem: 'diretoria13',
    },
    {
      nome: 'Julio Capua',
      cargo: 'Diretor',
      descricao: 'XP Investimentos',
      imagem: 'diretoria14',
    },
    {
      nome: 'Luiz Chrysostomo',
      cargo: 'Diretor',
      descricao: 'Neo Gestão de Recursos',
      imagem: 'diretoria15',
    },
    {
      nome: 'Luiz Fernando Figueiredo',
      cargo: 'Diretor',
      descricao: 'Mauá Investimentos',
      imagem: 'diretoria16',
    },
    {
      nome: 'Lywal Salles Filho',
      cargo: 'Diretor',
      descricao: 'Vinci Partners',
      imagem: 'diretoria17',
    },
    {
      nome: 'Pedro Juliano',
      cargo: 'Diretor',
      descricao: 'JP Morgan',
      imagem: 'diretoria18',
    },
    {
      nome: 'Pedro Rudge',
      cargo: 'Diretor',
      descricao: 'Leblon Equities',
      imagem: 'diretoria19',
    },
    {
      nome: 'Saša Markus',
      cargo: 'Diretor',
      descricao: 'Renascença DTVM',
      imagem: 'diretoria20',
    },
    {
      nome: 'Teodoro Lima',
      cargo: 'Diretor',
      descricao: 'Credit Suisse',
      imagem: 'diretoria21',
    },
    {
      nome: 'Thaís Peters',
      cargo: 'Diretora',
      descricao: 'Caixa',
      imagem: 'diretoria22',
    },
  ],
};

export { diretoria };
